// Wraps tables in div

function tableWrap()
{

    const matches = document.querySelectorAll('table:not(.no-wrapper)');

    for (let i = 0; i < matches.length; i++) {

        if (matches[i].parentNode.classList.contains('table-wrapper') !== true) {

            const modified = '<div class="table-wrapper">' + matches[i].outerHTML + '</div>';
            matches[i].outerHTML = modified;

        }

    }

}

export default function init()
{

    tableWrap();

}
